import { GeoJsonLayer } from "@deck.gl/layers";
import type { Feature } from "geojson";

const markerIconMapping = {
    marker: {
        x: 0,
        y: 0,
        width: 35,
        height: 54,
        anchorX: 17.5,
        anchorY: 54,
        mask: false,
    },
};

function markerIconAtlas() {
    const canvas = document.createElement("canvas");
    canvas.width = 35;
    canvas.height = 54;
    const ctx = canvas.getContext("2d");

    // Clear the canvas
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Scale the SVG path to fit our canvas dimensions
    // Original viewBox is 6 6 354 546, we're scaling to 35x54
    const scaleX = 35 / 354;
    const scaleY = 54 / 546;

    // Start drawing the path
    ctx.beginPath();

    // Move to the starting point (scaled from the SVG path)
    ctx.save();
    ctx.scale(scaleX, scaleY);
    ctx.translate(-6, -6); // Adjust for the viewBox offset

    // Draw the teardrop shape
    ctx.moveTo(182.9, 551.7);
    // Main teardrop outline
    ctx.bezierCurveTo(182.9, 551.8, 183.1, 552, 183.1, 552);
    ctx.bezierCurveTo(183.1, 552, 358.3, 283, 358.3, 194.6);
    ctx.bezierCurveTo(358.3, 64.5, 269.5, 7.9, 182.9, 7.7);
    ctx.bezierCurveTo(96.3, 7.9, 7.5, 64.5, 7.5, 194.6);
    ctx.bezierCurveTo(7.5, 283, 182.8, 552, 182.8, 552);
    ctx.bezierCurveTo(182.8, 552, 182.9, 551.7, 182.9, 551.7);

    // Draw the inner circle
    ctx.moveTo(243.7, 187.2);
    ctx.arc(182.9, 187.2, 60.8, 0, 2 * Math.PI);

    ctx.restore();

    // Fill the path with red color
    ctx.fillStyle = "#1677ff";
    ctx.fill();

    // Draw the white circle in the center
    const centerX = canvas.width / 2;
    const circleY = 18; // Positioned similar to the SVG
    const circleRadius = 6; // Scaled appropriately

    ctx.beginPath();
    ctx.arc(centerX, circleY, circleRadius, 0, 2 * Math.PI);
    ctx.fillStyle = "white";
    ctx.fill();

    return canvas;
}

export const MarkerLayer = (features: Feature[]) => {
    return [
        new GeoJsonLayer({
            id: "location-markers",
            data: { type: "FeatureCollection", features: features },
            pointType: "icon",
            iconAtlas: markerIconAtlas(),
            getIconSize: 28,
            getIcon: () => "marker",
            iconMapping: markerIconMapping,
            filled: true,
            stroked: true,
            pickable: false,
            autoHighlight: false,
            visible: true,
        }),
    ];
};
